import * as types from '../constants/actionTypes';

export const createQuotationRequest = (data) => ({
  type: types.CREATE_QUOTATION_REQUEST,
  payload: data,
});
export const createQuotationSuccess = (data) => ({
  type: types.CREATE_QUOTATION_SUCCESS,
  payload: data,
});
export const createQuotationFailure = (error) => ({
  type: types.CREATE_QUOTATION_FAILURE,
  payload: error,
});

export const fetchQuotationsRequest = (params = {}) => ({
  type: types.FETCH_QUOTATIONS_REQUEST,
  payload: params,
});
export const fetchQuotationsSuccess = (data) => ({
  type: types.FETCH_QUOTATIONS_SUCCESS,
  payload: data,
});
export const fetchQuotationsFailure = (error) => ({
  type: types.FETCH_QUOTATIONS_FAILURE,
  payload: error,
});

export const fetchQuotationRequest = (id) => ({
  type: types.FETCH_QUOTATION_REQUEST,
  payload: id,
});
export const fetchQuotationSuccess = (data) => ({
  type: types.FETCH_QUOTATION_SUCCESS,
  payload: data,
});
export const fetchQuotationFailure = (error) => ({
  type: types.FETCH_QUOTATION_FAILURE,
  payload: error,
});

export const updateQuotationStatusRequest = (id, status) => ({
  type: types.UPDATE_QUOTATION_STATUS_REQUEST,
  payload: { id, status },
});
export const updateQuotationStatusSuccess = (data) => ({
  type: types.UPDATE_QUOTATION_STATUS_SUCCESS,
  payload: data,
});
export const updateQuotationStatusFailure = (error) => ({
  type: types.UPDATE_QUOTATION_STATUS_FAILURE,
  payload: error,
});

// payload: { quotationId, purchaseOrderId }
export const convertQuotationRequest = (quotationId, purchaseOrderId) => ({
  type: types.CONVERT_QUOTATION_REQUEST,
  payload: { quotationId, purchaseOrderId },
});
export const convertQuotationSuccess = (data) => ({
  type: types.CONVERT_QUOTATION_SUCCESS,
  payload: data,
});
export const convertQuotationFailure = (error) => ({
  type: types.CONVERT_QUOTATION_FAILURE,
  payload: error,
});

export const fetchComparativeStatementRequest = (params = {}) => ({
  type: types.FETCH_COMPARATIVE_STATEMENT_REQUEST,
  payload: params,
});
export const fetchComparativeStatementSuccess = (data) => ({
  type: types.FETCH_COMPARATIVE_STATEMENT_SUCCESS,
  payload: data,
});
export const fetchComparativeStatementFailure = (error) => ({
  type: types.FETCH_COMPARATIVE_STATEMENT_FAILURE,
  payload: error,
});

export const clearQuotationError = () => ({
  type: types.CLEAR_QUOTATION_ERROR,
});
